import { Select, Radio, Space } from 'antd';
import { v4 as uuid } from 'uuid';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { BUTTON_VARIANT_DARK } from '../../../../../../../components/forms/ZorbaButton/constants';
import { ZorbaButton } from '../../../../../../../components/forms';
import { setAppliedFilters } from '../../../../../../../reducers/Offer/actions';

import { options } from '../constants';

import '../index.scss';

export const SourceBuilder = ({ onApplyFilter }) => {
  const dispatch = useDispatch();
  const { appliedFilters } = useSelector(({ OfferReducer }) => OfferReducer);
  const [defaultRadioValue] = Object.keys(appliedFilters.source ?? {});
  const defaultSelectValue = defaultRadioValue
    ? appliedFilters.source[defaultRadioValue]
    : [];

  const [radioValue, setRadioValue] = useState(defaultRadioValue);
  const [selectedSource, setSelectedSource] = useState(defaultSelectValue);
  const statusOptions = [
    { label: 'Wholesale', value: 'deal' },
    { label: 'Pre-Lock', value: 'pre-deal' },
  ];
  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleSelectChange = (newValue) => {
    setSelectedSource([newValue]);
  };

  const isApplyButtonDisabled = !radioValue || !selectedSource;
  const handleApply = () => {
    dispatch(
      setAppliedFilters('source', {
        [radioValue]: selectedSource,
      }),
    );
    onApplyFilter();
  };

  return (
    <div className="builder-container">
      <h3>Source</h3>
      <div className="options-container">
        <Radio.Group onChange={handleRadioChange} value={radioValue}>
          <Space direction="vertical">
            {options.map((option) => (
              <Radio key={uuid()} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {radioValue && (
          <Select
            className="select"
            placeholder="Select source"
            onChange={handleSelectChange}
            value={selectedSource}
            options={statusOptions}
          />
        )}
      </div>
      <ZorbaButton
        variant={BUTTON_VARIANT_DARK}
        disabled={isApplyButtonDisabled}
        onClick={handleApply}
        fullWidth={false}
      >
        Apply
      </ZorbaButton>
    </div>
  );
};
